import { KnowDocument } from 'interfaces/Know'

export function knowContentPreviewUrl(knowContent: KnowDocument) {
    return knowContent.previewSmallUrl
}
